import type { Item } from "../common";

export enum GeneratedInsightsFilterField {
    INSIGHT_TYPE = "GENERATED_INSIGHT_TYPE",
    BRAND = "GENERATED_BRAND",
    BROWSE_NODE = "GENERATED_BROWSE_NODE",
}

export type GeneratedInsightsFieldSelections = {
    [key in GeneratedInsightsFilterField]: Item;
};
export type GeneratedInsightsFilterOptions = {
    [key in GeneratedInsightsFilterField]: Item;
};
